import Login from './Login.json';

const fr = {
  Login,
};

export default fr;
